import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AuthorizedUploadIntent } from '@client/features/attachments/types';

/**
 * Upload a file to Attachment Storage after having authorized the file is OK
 * to upload.
 *
 * @see getUploadIntent()
 */
export async function uploadAttachmentUsingIntent(
  intent: AuthorizedUploadIntent,
  file: File,
  onUploadProgress: AxiosRequestConfig['onUploadProgress'],
): Promise<AxiosResponse> {
  // Using raw axios so it doesn't have our normal API-based HTTP headers and URI prefix
  const http = axios;

  const response = await http.request({
    method: intent.method,
    headers: intent.headers,
    url: intent.url,
    data: file,
    onUploadProgress,
  });

  if (response.status !== 200) {
    throw new Error('Encountered unexpected HTTP Status Code when uploading File to Storage');
  }

  return response;
}
